"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Creates a random guid
 * 
 * @param {*} length 
 */
const createGuid = (length = 16) => {
  return [...Array(length)].map(i => (~~(Math.random() * 36)).toString(36)).join('');
};

var _default = createGuid;
exports.default = _default;